export default "__VITE_ASSET__aMH_qPAW__"